<script lang="ts">
	import '../app.css';
	import { Navbar, NavBrand, NavLi, NavUl, NavHamburger } from 'flowbite-svelte';
	import { DarkMode } from 'flowbite-svelte';

	let { children } = $props();

</script>

<svelte:head>
<link rel="icon" type="image/svg+xml" href="/images/favicon.svg" />
</svelte:head>

<header>
		<Navbar class="dark:bg-secondary-500 max-w-screen-xl mx-auto">
		<NavBrand href="/#top">
			<img
				style="height:40px;"
				src="/images/mk-light-logo.svg"
				class="me-3 h-6 sm:h-9 block dark:hidden"
				alt="Michael Kreiselmeyer Logo"
			/>
			<img
				style="height:40px;"
				src="/images/mk-dark-logo.svg"
				class="me-3 h-6 sm:h-9 dark:block hidden"
				alt="Michael Kreiselmeyer Logo"
			/>
		</NavBrand>
		<NavHamburger />
		<NavUl>
			<NavLi href="/">Startseite</NavLi>
			<NavLi href="/#calculator">Steuersparpotenzial Rechner</NavLi>
			<NavLi href="/#about">Über uns</NavLi>
			<NavLi href="/#kontakt">Kontakt</NavLi>
			<DarkMode />
		</NavUl>
	</Navbar>
</header>

<main id="main-content" class="min-h-screen flex flex-col dark:bg-secondary-500">
	<div class="flex-1">
		{@render children()}
	</div>
</main>

	<footer class="p-4 bg-white md:p-8 lg:p-10 dark:bg-secondary-900">
		<div class="mx-auto max-w-screen-xl text-center">
			<a
				href="/"
				class="flex justify-center items-center text-2xl font-semibold text-gray-900 dark:text-white"
			>
				<img
					style="height:30px;"
					src="/images/mk-dark-logo.svg"
					class="me-3 h-6 sm:h-9 block dark:hidden"
					alt="Michael Kreiselmeyer Logo"
				/>
				<img
					style="height:30px;"
					src="/images/mk-light-logo.svg"
					class="me-3 h-6 sm:h-9 dark:block hidden"
					alt="Michael Kreiselmeyer Logo"
				/>
			</a>
			<p class="my-6 text-gray-500 dark:text-gray-400">
				Mit Leidenschaft setze ich mich für nachhaltige Lösungen ein, die wirtschaftlichen Erfolg
				und ökologische Verantwortung vereinen. Seit über 28 Jahren begleite ich Menschen dabei,
				ihre finanziellen Ziele zu erreichen, Potenziale zu entfalten und langfristige Werte zu
				schaffen.
			</p>
			<ul class="flex flex-wrap justify-center items-center mb-6 text-gray-900 dark:text-white">
				<li>
					<a href="#top" class="mr-4 hover:underline md:mr-6">Startseite</a>
				</li>
				<li>
					<a href="#calculator" class="mr-4 hover:underline md:mr-6">Steuersparpotenzial Rechner</a>
				</li>
				<li>
					<a href="#about" class="mr-4 hover:underline md:mr-6">Über uns</a>
				</li>
				<li>
					<a href="#kontakt" class="mr-4 hover:underline md:mr-6">Kontakt</a>
				</li>
				<li>
					<a
						target="_blank"
						href="https://michael-kreiselmeyer.de/impressum/"
						class="mr-4 hover:underline md:mr-6">Impressum</a
					>
				</li>
				<li>
					<a
						href="https://michael-kreiselmeyer.de/datenschutz/"
						class="mr-4 hover:underline md:mr-6"
						target="_blank">Datenschutz</a
					>
				</li>
				<li>
					<a
						href="https://michael-kreiselmeyer.de/barrierefreiheitserklaerung/"
						class="mr-4 hover:underline md:mr-6"
						target="_blank">Barrierefreiheitserklärung</a
					>
				</li>
			</ul>
			<span class="text-sm text-gray-500 sm:text-center dark:text-gray-400"
				>© <a href="https://michael-kreiselmeyer.de/" class="hover:underline"
					>Michael Kreiselmeyer</a
				> - Alle Rechte vorbehalten</span
			><br />
			<div class="text-sm mt-12 text-gray-500 sm:text-center dark:text-gray-400">
				Made with <svg
					class="inline text-red-500 dark:text-red-500"
					aria-hidden="true"
					focusable="false"
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					fill="currentColor"
					viewBox="0 0 24 24"
					role="img"
				>
					<path
						d="m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z"
					/>
				</svg>
				by <a href="https://www.farbenfeuer.com" class="hover:underline">Farbenfeuer GmbH</a>.
			</div>
		</div>
	</footer>
